export default "__VITE_PUBLIC_ASSET__f4a67385__"